import { render, staticRenderFns } from "./Activated.vue?vue&type=template&id=8556460c"
import script from "./Activated.vue?vue&type=script&lang=js"
export * from "./Activated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports